import {
  LIBREVIEW_PAGE_NOTIFICATION,
  LIBREVIEW_SERVICES_NOTIFICATION,
} from '../../../definitions/NotificationConstants';
import { BACKENDNOTIFICATIONS } from '../../reducer';
import {
  notificationIsFetching,
  notificationShouldBeVisible,
} from '../selector';
import { doRequestDismissNotifications } from '../../notification/actions';
import Logger from '../../../utils/Logger';

const createActionName =
  require('../../util').createActionName('services/libreview');

let { id: module_id } = module;
const logger = new Logger(module_id);

export const LIBREVIEW_REDIRECT_URL_RECEIVE = createActionName(
  'LIBREVIEW_REDIRECT_URL_RECEIVE'
);
export const LIBREVIEW_AUTHENTICATION_REQUEST = createActionName(
  'LIBREVIEW_AUTHENTICATION_REQUEST'
);
export const LIBREVIEW_AUTHENTICATION_RECEIVE = createActionName(
  'LIBREVIEW_AUTHENTICATION_RECEIVE'
);

export const receiveRedirectUrl = (data) => ({
  type: LIBREVIEW_REDIRECT_URL_RECEIVE,
  payload: data,
});

export const requestAuthentication = () => ({
  type: LIBREVIEW_AUTHENTICATION_REQUEST,
});

export const receiveAuthentication = (data) => ({
  type: LIBREVIEW_AUTHENTICATION_RECEIVE,
  payload: data,
});

//When user has libreview status "user", get URL for Libreview where user logs in
export const doRedirect = () => (dispatch, getState, services) => {
  return services.api
    .libreviewRedirect()
    .then((data) => {
      return dispatch(receiveRedirectUrl(data));
    })
    .catch((err) => {
      console.log(err);
      return err;
    });
};

//When user has logged in and been redirected back to OT, authentication process is handled
// in backend with Libreview and Id-merger
export const doAuthenticate = (authCode) => (dispatch, getState, services) => {
  dispatch(requestAuthentication());
  services.api
    .libreviewAuthentication({ payload: authCode })
    .then((isSuccessful) => {
      dispatch(receiveAuthentication(isSuccessful));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const automaticallyDismissLibreviewActivationNotification =
  () => (dispatch, getState) => {
    let state = getState();
    let { data: notificationData } = state[BACKENDNOTIFICATIONS];

    if (
      notificationShouldBeVisible(LIBREVIEW_SERVICES_NOTIFICATION)(
        notificationData
      ) &&
      !notificationIsFetching(LIBREVIEW_PAGE_NOTIFICATION)(notificationData)
    ) {
      logger.debug('dispatching dismiss service activation notification');
      dispatch(
        doRequestDismissNotifications([LIBREVIEW_SERVICES_NOTIFICATION])
      );
    }
  };
